export default class MassiaSelectService {
	static $inject = ['$http'];

	constructor($http) {
		this.$http = $http;
	}

	async getSocietesCom() {
		let url = `${__configuration.apiUrl}/massia/societes-commerciales`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getSites(pIdSociete) {
		let url = '';
		if (pIdSociete == '' || typeof pIdSociete === 'undefined' || pIdSociete == '0') url = `${__configuration.apiUrl}/massia/sites/headers/`;
		else url = `${__configuration.apiUrl}/massia/sites/header/${pIdSociete}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getSitesCom(pIdSociete) {
		let url = '';
		if (pIdSociete == '' || typeof pIdSociete === 'undefined' || pIdSociete == '0')
			url = `${__configuration.apiUrl}/massia/sites-commerciaux/headers/`;
		else url = `${__configuration.apiUrl}/massia/sites-commerciaux/header/${pIdSociete}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getSitesTransporteur(pIdSociete) {
		let url = '';
		if (pIdSociete == '' || typeof pIdSociete === 'undefined' || pIdSociete == '0')
			url = `${__configuration.apiUrl}/massia/sites-transporteurs/headers`;
		else url = `${__configuration.apiUrl}/massia/sites-transporteurs/header/${pIdSociete}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getClients(idSociete) {
		if (idSociete == '' || typeof idSociete === 'undefined' || idSociete == '0') {
			let url = `${__configuration.apiUrl}/massia/sites-clients`;
			let res = await this.$http.get(url);
			return res.data.items;
		} else {
			let url = `${__configuration.apiUrl}/massia/sites-clients/header/${idSociete}`;
			let res = await this.$http.get(url);
			return res.data;
		}
	}

	async getBennes(Id) {
		if (Id == '' || typeof Id === 'undefined' || Id == '0') {
			let url = `${__configuration.apiUrl}/massia/gestion/bennes`;
			let res = await this.$http.get(url);
			return res.data.items;
		} else {
			let url = `${__configuration.apiUrl}/massia/gestion/bennes/lite/${Id}`;
			let res = await this.$http.get(url);
			return res.data;
		}
	}

	async getTracteurs() {
		let url = `${__configuration.apiUrl}/massia/gestion/tracteurs/lite`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getVehicules(idTransporteur) {
		if (idTransporteur == '' || typeof idTransporteur === 'undefined' || idTransporteur == '0') {
			let url = `${__configuration.apiUrl}/massia/vehicules?isEnabled=true`;
			let res = await this.$http.get(url);
			return res.data.items;
		} else {
			let url = `${__configuration.apiUrl}/massia/vehicules/lite/${idTransporteur}`;
			let res = await this.$http.get(url);
			return res.data;
		}
	}

	async getTransporteurs(idSiteCommercial) {
		let url = '';
		if (idSiteCommercial == '' || typeof idSiteCommercial === 'undefined' || idSiteCommercial == '0')
			url = `${__configuration.apiUrl}/massia/sites-transporteurs/all`;
		else url = `${__configuration.apiUrl}/massia/sites-transporteurs/typeAheadCompteOuvertSiteComm/${idSiteCommercial}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getChauffeurs(siteTransporteurId) {
		let url = `${__configuration.apiUrl}/massia/personnes/chauffeurs`;
		let params = {
			societeId: 0,
			siteTransporteurId: siteTransporteurId === -1 ? null : siteTransporteurId,
			withFiltres: false
		};

		try {
			let res = await this.$http.get(url, { params: params });
			return res.data;
		} catch (error) {
			console.error('Chauffeurs:', error);
			throw error;
		}
	}

	async getFournisseurs(idSiteCommercial) {
		let url = '';
		if (idSiteCommercial == '' || typeof idSiteCommercial === 'undefined' || idSiteCommercial == '0')
			url = `${__configuration.apiUrl}/massia/sites-fournisseurs/all`;
		else url = `${__configuration.apiUrl}/massia/sites-fournisseurs/typeAhead-by-site/gestion/${idSiteCommercial}/all`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getProvenances(idFournisseur) {
		if (idFournisseur == '' || typeof idFournisseur === 'undefined' || idFournisseur == '0') {
			let url = `${__configuration.apiUrl}/massia/chantiers`;
			let res = await this.$http.get(url);
			return res.data.items;
		} else {
			let url = `${__configuration.apiUrl}/massia/chantiers/headersByClient/${idFournisseur}`;
			let res = await this.$http.get(url);
			return res.data;
		}
	}

	async getCommandes(idProvenance) {
		// Non finalisé car pour le moment les bls d'appro n'ont pas de num de commande
		if (idProvenance == '' || typeof idProvenance === 'undefined' || idProvenance == '0') {
			let url = `${__configuration.apiUrl}/massia/commandes`;
			let res = await this.$http.get(url);
			return res.data.items;
		} else {
			let url = `${__configuration.apiUrl}/massia/commandes/headerByClient/${idProvenance}/all`;
			let res = await this.$http.get(url);
			return res.data;
		}
	}

	async getProduits(idSiteCommercial) {
		let url = '';
		if (idSiteCommercial == '' || typeof idSiteCommercial === 'undefined' || idSiteCommercial == '0')
			url = `${__configuration.apiUrl}/massia/_form/produits/0/entree`;
		else url = `${__configuration.apiUrl}/massia/_form/produits/${idSiteCommercial}/entree`;
		let res = await this.$http.get(url);
		return res.data;
	}

	//headerByClient/{idClient}/{valeur}
}
